import * as actionTypes from '../actionTypes/Gestures'
import { deletePropertyFromObject } from '../utility'

const initialState = {
    staticGestures: {},
}

const addGesture = (state, data) => {
    return {
        ...state,
        staticGestures: {
            ...state.staticGestures,
            [data.gesture_pk]: data,
        },
    }
}

const removeGesture = (state, data) => {
    if (data && data.gesture_pk && state.staticGestures[data.gesture_pk]) {
        return {
            ...state,
            staticGestures: deletePropertyFromObject(
                data.gesture_pk,
                state.staticGestures
            ),
        }
    }
    return state
}

const Gestures = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADD_GESTURE:
            return addGesture(state, action.data)
        case actionTypes.REMOVE_GESTURE:
            return removeGesture(state, action.data)
        default:
            return state
    }
}

export default Gestures
